import { Component } from 'preact'
import cx from 'classnames'
import Markdown from 'preact-markdown'

import { IconConfirmSolid } from '../icons/confirm-solid'
import { IconUnconfirmSolid } from '../icons/unconfirm-solid'
import CollapsibleSection from './collapsible-section'
import RowSelect, { RowSelectWithFooter } from './row-select'
import SelectGroup from './select-group'
import Separator from './separator'
import s from './summary-section.sass'
import gs from './generic-sign-up.sass'
import ActionButton from '../action-button'
import PriceSummary from './price-summary'
import { isMobile } from '../../helpers/devices'
import GymCardV2 from '../gym-card-v2'
import { connect } from 'unistore/preact'
import { getPriceAndLabel } from './selectors'
import { GridSelectWithFooter } from './step-wizard/upgrade-section'
import { purchaseFunnelSummary, purchaseFunnelSummaryAddOn, purchaseFunnelSummaryPay, shareUrl } from '../../helpers/analytics'
import { richTextToMarkdown } from '../../helpers/cms'
import Modal from '../modal'
import { IconInfoSolid } from '../icons/info-solid'
import WarningMessage from './warning-message'
import cuid from 'cuid'

class AddOnsRow extends Component {
  state = { showModal: false }

  handleOnClick (event) {
    event.preventDefault()
    this.setState({ showModal: true })
  }

  render ({
    addOn,
    renderAddOn,
    handleOnInfo,
    isRecurring,
    ...rest
  }, {
    showModal
  }) {
    return (
      <div className={s.addOnsRow}>
        <RowSelect
          {...rest}
          className={s.addOnsItem}
          value={addOn.type.toString()}
          onClick={(e) => purchaseFunnelSummaryAddOn(e.target.value)}
          render={(checked) => [
            checked ? <IconConfirmSolid /> : <IconUnconfirmSolid />,
            <span>{renderAddOn.name}{renderAddOn.description && ` (${renderAddOn.description})`}</span>,
            <IconInfoSolid className={s.addOnsInfo} onClick={(event) => this.handleOnClick(event)} />,
            <span>+{addOn.priceSEK}kr{isRecurring && '/mån'}</span>
          ]}
        />
        {showModal && <Modal
          onClose={() => this.setState({ showModal: false })}
          fullscreen
          centered
          noScroll
          title={renderAddOn.name}
          acceptText='Okej'
        >
          <p>{renderAddOn.info}</p>
        </Modal>}
      </div>
    )
  }
}

class IncludedAddOnsRow extends Component {
  state = { showModal: false }

  render ({
    addOn,
    renderAddOn,
    handleOnInfo,
    ...rest
  }, {
    showModal
  }) {
    return (
      <div>
        <RowSelect
          {...rest}
          className={s.includedAddOnsItem}
          nonInteractive
          checked
        >
          <span>{renderAddOn.name}{renderAddOn.description && ` (${renderAddOn.description})`}</span>
          <IconInfoSolid className={s.addOnsInfo} onClick={() => this.setState({ showModal: true })} />
        </RowSelect>
        {showModal && <Modal
          onClose={() => this.setState({ showModal: false })}
          fullscreen
          centered
          noScroll
          title={renderAddOn.name}
          acceptText='Okej'
        >
          <Markdown markdown={renderAddOn.info || ''} />
        </Modal>}
      </div>
    )
  }
}

class SummarySection extends Component {
  componentDidMount () {
    if (this.props.onMount) {
      this.props.onMount()
    }
  }

  onShare () {
    return navigator.clipboard.writeText(window.location.toString()).then(() => {
      shareUrl(cuid())
    })
  }

  handleOnExpand () {
    this.props.onExpand()
    purchaseFunnelSummary()
  }

  handleOnToNext () {
    const { inputs, addOnsValue } = this.props
    purchaseFunnelSummaryPay(inputs.upgrade, addOnsValue)
    this.props.onToPayment()
  }

  getValidWarnings (warning) {
    return warning &&
      Array.isArray(warning) &&
      warning.length > 0 &&
      warning.filter(warning => warning.text !== '')
  }

  render ({
    srcData,
    title,
    inputs,
    onEdit,
    addOnsCopy,
    addOnsValue,
    handleOnAddOn,
    includesTitle,
    includes,
    onToPayment,
    isCollapsed,
    onExpand,
    suggestion,
    hideSeparator,
    noPadding,
    signUpPrices,
    disableEdits,
    price,
    ...rest
  }) {
    const combinedClassNames = cx(
      s.summarySection,
      noPadding && s.noPadding
    )

    const validWarnings = this.getValidWarnings(suggestion && suggestion.warningMessage)
    const suggestionHasWarning = Array.isArray(validWarnings) && validWarnings.length > 0

    return (
      <CollapsibleSection
        className={combinedClassNames}
        onExpand={() => this.handleOnExpand()}
        isCollapsed={isCollapsed}
      >
        {!hideSeparator && <Separator className={gs.signUpSeparator} />}

        <div className={s.content}>
          <h2>{title}</h2>

          <div className={s.summary}>
            <div className={s.cardContainer}>
              <GymCardV2 className={s.card} color={(suggestion && suggestion.cardColor)} text={suggestion && suggestion.title} />
            </div>
            <div>
              <div className={s.summaryList}>
                {Object.keys(inputs).map((inputKey, key) => {
                  const v = inputs[inputKey] && srcData[inputKey].inputs.find(e => e.value === inputs[inputKey] || (e.id && e.id === inputs[inputKey]))

                  const rowProps = !disableEdits
                    ? { editProp: () => onEdit(inputKey) }
                    : { nonInteractive: true }

                  return v
                    ? (
                      <RowSelect
                        key={`input-${key}`}
                        className={s.summaryItem}
                        checked
                        onClick={() => onEdit(inputKey)}
                        {...rowProps}
                      >
                        <IconConfirmSolid />
                        {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}
                        {!disableEdits && <button className={s.edit} onClick={() => onEdit(inputKey)}>Ändra</button>}
                      </RowSelect>
                    )
                    : null
                })}
                {suggestion && suggestion.includedAddOns.map((addOnKey, key) => {
                  const v = addOnsCopy[addOnKey]
                  return v
                    ? <IncludedAddOnsRow value={addOnKey} renderAddOn={v} />
                    : null
                })}
                {suggestionHasWarning &&
                  <WarningMessage message={richTextToMarkdown(suggestion.warningMessage)} />}
              </div>
              {suggestion && suggestion.availableAddOns.length > 0 &&
                <div>
                  <Separator className={s.addOnsSeparator}>Lägg till</Separator>
                  <SelectGroup
                    className={s.addOnsList}
                    onChange={handleOnAddOn}
                    value={addOnsValue}
                  >
                    {suggestion && suggestion.availableAddOns.map((addOn, key) => {
                      const addOnKey = addOn.type.toString()
                      const renderAddOn = addOnsCopy[addOnKey]

                      return renderAddOn
                        ? <AddOnsRow isRecurring={suggestion.isRecurring} value={addOn.type.toString()} addOn={addOn} renderAddOn={renderAddOn} />
                        : null
                    })}
                  </SelectGroup>
                </div>
              }
            </div>
          </div>
          <h4>{includesTitle}</h4>
          <div className={s.includes}>
            {includes.map(({ linkLabel, linkUrl, ...included }, key) => isMobile()
              ? (
                <RowSelectWithFooter
                  key={key}
                  className={s.includeRow}
                  footerChildren={linkUrl && <a className={gs.signUpLink} href={linkUrl} target='_blank' rel='noopener'>{linkLabel || linkUrl}</a>}
                  {...included}
                  nonInteractive
                  backgroundOpacity={1}
                >
                  <IconConfirmSolid />
                  {included.name}
                </RowSelectWithFooter>
              )
              : <GridSelectWithFooter
                key={key}
                {...included}
                nonInteractive
                backgroundOpacity={1}
                children={linkUrl && <a className={gs.signUpLink} href={linkUrl} target='_blank' rel='noopener'>{linkLabel || linkUrl}</a>}
              />
            )}
          </div>
          <PriceSummary
            label={price && price.label}
            amount={price && price.amount}
          >
            <ActionButton label='Välj och gå vidare' onClick={() => this.handleOnToNext()} />
          </PriceSummary>
        </div>
      </CollapsibleSection>
    )
  }
}

export const selectors = (state) => {
  return {
    price: getPriceAndLabel(state),
    signUpPrices: state.signUpPrices
  }
}

export default connect(selectors)(SummarySection)



// WEBPACK FOOTER //
// ./components/signup-flow/summary-section.js